<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-25 16:47:11
 * @FilePath: /wemeet-admin-new/src/views/marketing/components/sendMessage.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    title="投放短信"
  >
    <div>
      <div class="basicMessage">
        <div class="desc">【WeMeet】尊敬的{ 张三 },您已报名参加</div>
        <el-input v-model="param.static1" maxlength="50" placeholder="建议您输入活动名称" style="width: 250px" />
        <div class="desc">。</div>
        <el-input v-model="param.static2" maxlength="50" placeholder="建议您输入活动信息" style="width: 400px" />
        <div class="desc">，期待您的莅临。</div>
      </div>
    </div>

    <div style="margin-top: 20px">
      <el-button @click="sendMessage">短信投放 本次将发送给 {{ row.userNum }}个人。</el-button>
      <el-button @click="goToWeChat">公众号信息 点击前往公众号发送</el-button>
    </div>

    <el-drawer ref="drawerRef" v-model="dialogFormVisible1" :append-to-body="true" :size="size1" title="填写驳回原因">
      <el-form ref="reasonRef" :model="form" :rules="rules">
        <el-form-item label="原因" prop="reason">
          <el-input v-model="form.reason" type="textarea" />
        </el-form-item>
        <el-form-item align="center">
          <el-button size="large" type="primary" @click="refuse">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import {
    getEnterpriseMarketingQueryMessageTemplate,
    attendAudit,
    getEnterpriseMarketingSendMessage,
    getEnterpriseMarketingPhoneMessageSend,
  } from '@/api/exhibitionManage'
  export default defineComponent({
    name: 'SendMessage',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        dialogFormVisible1: false,
        direction: 'rtl',
        size: '50%',
        size1: '30%',
        detail: {
          attentFormDtoList: [],
        },
        param: {
          static1: '',
          static2: '',
          static3: '',
        },
        checkType: 'message',
        rules: {
          reason: [
            {
              required: true,
              message: '请填写驳回原因',
              trigger: 'blur',
            },
          ],
        },
        statusList: {
          PENDING_REVIEW: '待审核',
          ACCEPT: `审核通过`,
          REFUSE: '审核不通过',
          CANCEL_SIGN: `取消报名`,
          NOT_REVIEW: `无需审核`,
        },
        form: {
          reason: '',
        },
        identityCard: {
          CERTIFICATES_TYPE_1: '身份证',
          CERTIFICATES_TYPE_2: '回乡证',
          CERTIFICATES_TYPE_3: '台胞证',
          CERTIFICATES_TYPE_4: '外国人永久居住证',
          CERTIFICATES_TYPE_5: '外国护照',
          CERTIFICATES_TYPE_6: '军人证',
          CERTIFICATES_TYPE_7: '外国人手机验证码认证',
          CERTIFICATES_TYPE_8: '港澳台居民居住证',
          CERTIFICATES_TYPE_99: '其他',
        },
        reasonRef: null,
        row: null,
      })
      // 打开
      const handleOpen = async (row) => {
        console.log(row)
        state.row = row
        state.dialogFormVisible = true
        const { data } = await getEnterpriseMarketingQueryMessageTemplate()
      }
      // 关闭
      const handleClose = () => {
        state.param = {
          static1: '',
          static2: '',
        }
        state.dialogFormVisible = false
        state.dialogFormVisible1 = false
      }

      const refuse = async () => {
        state['reasonRef'].validate(async (valid) => {
          if (valid) {
            try {
              let parmas = {
                audienceUid: state.row.audienceUid,
                auditStatus: 'REFUSE',
                entranceCode: '',
                identity: state.row.identity,
                meetingCode: props.meetingCode,
                meetingType: props.meetingCode.startsWith('MT') ? 'HOLD_MEETING' : 'EXHIBITION',
                reason: state.form.reason,
              }
              const { data } = await attendAudit(parmas)
              proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            } catch (err) {
              console.log(err)
              proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
            }
            emit('fetch-data')
            handleClose()
          }
        })
      }
      const accept = async () => {
        try {
          let parmas = {
            audienceUid: state.row.audienceUid,
            auditStatus: 'ACCEPT',
            entranceCode: '',
            identity: state.row.identity,
            meetingCode: props.meetingCode,
            meetingType: props.meetingCode.startsWith('MT') ? 'HOLD_MEETING' : 'EXHIBITION',
            reason: state.form.reason,
          }
          const { data } = await attendAudit(parmas)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (err) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }
        emit('fetch-data')
        handleClose()
      }

      const sendMessage = async () => {
        if (!state.param.static1 || !state.param.static2) {
          proxy.$baseMessage(`请填写短信内容`, 'error', 'vab-hey-message-error')
          return false
        }
        if (!state.row.phone) {
          let dataParams = {
            deliveryId: state.row.id,
            messageSceneCode: 'SMS_MARKET',
            params: [`{name}`, state.param.static1, state.param.static2],
          }
          const { data } = await getEnterpriseMarketingSendMessage(dataParams)
          proxy.$baseMessage(`短信已发送`, 'success', 'vab-hey-message-success')
          handleClose()
        } else {
          let dataParams = {
            messageSceneCode: 'SMS_MARKET',
            params: [`{name}`, state.param.static1, state.param.static2],
            phone: state.row.phone,
          }
          const { data } = await getEnterpriseMarketingPhoneMessageSend(dataParams)
          proxy.$baseMessage(`短信已发送`, 'success', 'vab-hey-message-success')
          handleClose()
        }
      }

      const goToWeChat = () => {
        window.open(`https://mp.weixin.qq.com/`)
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        refuse,
        accept,
        sendMessage,
        goToWeChat,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }

    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }

  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }

  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }

  .margin-top {
    margin-top: 20px;
  }

  .basicMessage {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    line-height: 50px;

    .desc {
      margin: 0 10px;
    }
  }
</style>
